import Browsers from '../../_shared/constants/Browsers';
import Swiper from 'swiper/bundle';

export function swiper() {
  //spのみ
  if (Browsers.mobile) {
    //カテゴリートップ商品一覧
    const categorylistProduct = new Swiper('.p_collection_listRowProduct',{
      slidesPerView: 'auto',
      centeredSlides: true,
      loop: true,
      spaceBetween: 20,
    })
    //閲覧履歴
    const p_productDetail_history = document.body.querySelector('.p_productDetail_history')
    if(p_productDetail_history){
      const check_productDetail_history = setInterval(()=>{
        const p_productDetail_history_link = document.body.querySelector('.p_productDetail_history .el_cardProduct_link')
        //console.log(p_productDetail_history_link)
        if(p_productDetail_history_link.getAttribute('href') !== "#"){
          clearInterval(check_productDetail_history)
          const productdetailHistory = new Swiper('.p_productDetail_history',{
            slidesPerView: 'auto',
            centeredSlides: true,
            loop: true,
            spaceBetween: 20,
            pagination: {
              el: '.swiper-pagination',
              clickable: true,
            },
          })
        }
      },1000)
    }

    //おすすめ商品
    if(document.body.querySelector('.p_productDetail_recommend')){
      var productdetailrecommendItem_timer = setInterval(function() {
        const item = document.body.querySelector('.p_productDetail_recommend .bl_listProduct_item')
        if (item) {
          const container = new Swiper('.p_productDetail_recommend',{
            slidesPerView: 'auto',
            centeredSlides: true,
            loop: true,
            spaceBetween: 22,
            pagination: {
              el: '.swiper-pagination',
              clickable: true,
            },
          })
          clearInterval(productdetailrecommendItem_timer)
        }
      }, 500)
    }

    const homeNew = new Swiper('.p_home_newItem',{
        slidesPerView: 'auto',
        centeredSlides: true,
        loop: true,
        spaceBetween: 12,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
    })
    const homeCategory = new Swiper('.p_home_categoryItem',{
      slidesPerView: 'auto',
      centeredSlides: true,
      loop: true,
      spaceBetween: 20,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
    })
    const homeBrand = new Swiper('.p_home_brandItem',{
      slidesPerView: 'auto',
      centeredSlides: true,
      loop: true,
      spaceBetween: 20,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
    })
    const homeRanking = new Swiper('.p_home_rankingItem',{
      slidesPerView: 'auto',
      centeredSlides: true,
      loop: true,
      spaceBetween: 20,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
    })

    if(document.body.querySelector('.p_home_recommendItem')){
      var recommendItem_timer = setInterval(function() {
        const item = document.body.querySelector('.p_home_recommendItem .bl_listProduct_item')
        if (item) {
          const container = new Swiper('.p_home_recommendItem',{
            slidesPerView: 'auto',
            centeredSlides: true,
            loop: true,
            spaceBetween: 22,
            pagination: {
              el: '.swiper-pagination',
              clickable: true,
            },
          })
          clearInterval(recommendItem_timer)
        }
      }, 500)
    }
  }
  const homeFeature = new Swiper('.p_home_slideImg',{
    slidesPerView: 'auto',
    centeredSlides: false,
    // loop: true,
    effect: "fade",
    /* これが必要 */
    fadeEffect: {
      crossFade: true
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
  })
  const product_thumbnails = new Swiper('.p_productDetail_leftThumbInner', {
    slidesPerView: 'auto',
  })
}
